import {createRequestDataSource} from '@ngneat/elf-requests';
import {select} from '@ngneat/elf';
import {entitiesPropsFactory, selectAllEntities} from '@ngneat/elf-entities';

import {wasteFamiliesStore} from '@store/settings/wasteFamilies/wasteFamilies.store';

const {wasteEntitiesRef} = entitiesPropsFactory('waste');

export const getWasteFamiliesDataSource = createRequestDataSource({
  store: wasteFamiliesStore,
  data$: () => wasteFamiliesStore.pipe(
    select((state) =>
      Object.values(state.entities).filter((wasteFamily) => state.pagination.pages[state.pagination.currentPage].includes(wasteFamily.id))
    ),
  ),
  requestKey: 'getWasteFamilies',
  dataKey: 'wasteFamilies',
});

export const getWasteDataSource = createRequestDataSource({
  store: wasteFamiliesStore,
  data$: () => wasteFamiliesStore.pipe(selectAllEntities({ref: wasteEntitiesRef})),
  requestKey: 'getAllWaste',
  dataKey: 'allWaste',
});